export default __webpack_public_path__ + "static/pict3Placeholder-709f92ac720a2043d14fc7c033df9eec.png";